import React from 'react';
import { Typography, message } from 'antd';
import { updateSimFriendlyName } from '../services/adminService';
import { blurStyle } from '../utils/redact';

type Props = {
  assignmentId: number | null | undefined;
  value: string | null | undefined;
  canEdit: boolean;
  onSaved?: (next: string | null) => void;
  blurred?: boolean;
};

const EditableFriendlyName: React.FC<Props> = ({
  assignmentId,
  value,
  canEdit,
  onSaved,
  blurred = false,
}) => {
  const current = value || '';

  if (assignmentId == null) {
    return <span style={blurStyle(blurred)}>{current || '—'}</span>;
  }

  if (!canEdit) {
    return <span style={blurStyle(blurred)}>{current || '—'}</span>;
  }

  const handleChange = async (v: string) => {
    const trimmed = (v ?? '').trim();
    const next = trimmed === '' ? null : trimmed;
    try {
      await updateSimFriendlyName(assignmentId, next);
      message.success('Friendly name updated');
      onSaved?.(next);
    } catch (err: any) {
      message.error(err?.message || 'Failed to update friendly name');
    }
  };

  return (
    <Typography.Text
      style={blurStyle(blurred)}
      editable={{
        maxLength: 100,
        tooltip: 'Click to edit',
        onChange: handleChange,
      }}
    >
      {current}
    </Typography.Text>
  );
};

export default EditableFriendlyName;
